// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL_UI
import CircularProgress from '@mui/material/CircularProgress';
// STYLE

import { miEdgeBlue500 } from '../../../styles/miEdgeColors';
// EXPORTED COMPONENT
// =========================
class LoadingState extends React.PureComponent {
  render() {
    const { pageTitle } = this.props;
    return (
      <div>
        <div style={{ display: 'flex' }}>
          <CircularProgress
            disableShrink
            size={60}
            style={{
              marginLeft: 'calc(50% - 30px)',
              marginTop: '60px',
            }}
          />
        </div>
        <div className="row center-xs">
          <div className="col-xs-12 center-xs">
            <h2 style={{ padding: 20, color: miEdgeBlue500, marginTop: '60px' }}>{pageTitle}</h2>
          </div>
        </div>
      </div>
    );
  }
}

// PROPS
// =========================
LoadingState.propTypes = {
  pageTitle: PropTypes.string,
};

LoadingState.defaultProps = {
  pageTitle: 'Loading...',
};

// EXPORT
// =========================
export default LoadingState;
